import { render, staticRenderFns } from "./IntraOperatorio.vue?vue&type=template&id=2c8a5c01"
import script from "./IntraOperatorio.vue?vue&type=script&lang=js"
export * from "./IntraOperatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports